import React, { useEffect } from "react";
import PaginationFooter from "./PaginationFooter";
import debounce from "debounce";
import { searchGlobalContent } from "common/services/search.service";
import { DEBOUNCE_TIME } from "common/constants";
import LoadingItem from "../Items/LoadingItem";
import ResultsNotFound from "../Items/ResultsNotFound";
import { determineEntityType } from "common/lib/entityType";
import RequestItem from "../Items/RequestItem";

const tab = "6";
const Requests = ({
  searchValue,
  activeTab,
}: {
  searchValue: string;
  activeTab: string;
}) => {
  const [searchResults, setSearchResults] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [page, setPage] = React.useState<number>(1);
  const [totalPages, setTotalPages] = React.useState<number>(0);

  useEffect(() => {
    const search = debounce(async () => {
      try {
        setLoading(true);
        const response: any = await searchGlobalContent({
          query: searchValue,
          pageSize: 20,
          page: page,
          index: "government-request",
        });

        setSearchResults(response.hits);
        setPage(response?.page);
        setTotalPages(response?.totalPages);
        setLoading(false);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }, DEBOUNCE_TIME);

    if (activeTab === tab) {
      search();
    }
    return () => {
      search.clear();
    };
  }, [searchValue, page, activeTab]);

  useEffect(() => {
    setPage(1);
  }, [searchValue]);

  if (loading) {
    return Array.from({ length: 10 }).map((_, index) => (
      <div key={index}>
        {index !== 0 && <div className="border border-dashed"></div>}
        <LoadingItem key={index} />
      </div>
    ));
  }

  if (
    searchResults.length === 0 &&
    (searchValue !== "" || searchValue !== null)
  ) {
    return <ResultsNotFound />;
  }

  return (
    <>
      {searchResults.map((result: any, index: number) => {
        const entityType: string = determineEntityType(result._meilisearch_id);

        if (entityType === "government-request") {
          return (
            <div key={result.id}>
              {index !== 0 && <div className="border border-dashed"></div>}
              <RequestItem data={result} index={index} />
            </div>
          );
        }

        return null;
      })}

      <PaginationFooter
        page={page}
        totalPages={totalPages}
        onPageChange={(page: number) => setPage(page)}
      />
    </>
  );
};

export default Requests;
